import axios from 'axios';
import { CONFIG } from '@/config/Config';
import { addSessionId } from '@/core/utils/httpHeaders';
import { getAccountId, getUniId } from '@/core/utils/extractCookieId';
import { AuthorOption, AuthorApiDoc, AuthorSearchApiResponse } from './interfaces/AuthorInterfaces';

const add_authors = (api_authors: AuthorApiDoc[]): AuthorOption[] => {
  const grouped_authors = api_authors.reduce((acc, current_author) => {
    if (!current_author.username) return acc;

    const unique_key = `${current_author.channel}_${current_author.username}`;

    if (!acc[unique_key]) {
      acc[unique_key] = {
        uid: current_author.uid,
        uids: [],
        name: current_author.name,
        username: current_author.username,
        channel: current_author.channel,
        followers: current_author.followers,
        isVerified: current_author.is_verified,
        profilePicture: current_author.profile_picture,
      };
    }

    acc[unique_key].uids.push(current_author.uid);

    return acc;
  }, {} as Record<string, AuthorOption>);

  return Object.values(grouped_authors);
};

class AuthorService {
  async searchAuthors(search_term: string): Promise<AuthorOption[]> {
    const clean_term = search_term.trim();
    
    if (!clean_term) return [];

    const base_url = CONFIG.getServiceUrl('stilingue-endpoint');
    const request_url = `${base_url}/endpoint/search_user`;
    const request_headers = addSessionId({ accept: 'application/json' });

    try {
      const response = await axios.get<AuthorSearchApiResponse>(request_url, {
        headers: request_headers,
        params: {
          q: clean_term,
          data_type: 'user_search',
          account_id: getAccountId(),
          universe_id: getUniId(),
        },
      });

      const raw_authors = response.data.response.docs;
      
      return add_authors(raw_authors);
      
    } catch (error) {
      console.error('Failed to search authors:', error);
      return [];
    }
  }
}

const authorService = new AuthorService();
export default authorService;